export * from "./Product-Features";
export * from "./efficiency";
export * from "./video";
export * from "./comparision";
export * from "./related_products";
export * from "./productdetail_form";
export * from "./resource";
export * from "./variation";
